import { useState } from 'preact/hooks';
import { route } from 'preact-router';
import Button from '../components/shared/Button.jsx';
import Card from '../components/shared/Card.jsx';

export default function LoginView({ onLoggedIn }) {
  const [step, setStep] = useState('credentials');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submitCredentials(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ email, password })
      });
      const data = res.headers.get('content-type')?.includes('application/json')
        ? await res.json()
        : {};
      if (!res.ok) throw new Error(data.error || 'login_failed');
      if (data.requireMfa) {
        setStep('mfa');
        setError(null);
      }
    } catch (err) {
      setError(translate(err.message));
    } finally {
      setBusy(false);
    }
  }

  async function submitMfa(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch('/api/auth/mfa/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ code: code.trim() })
      });
      const data = res.headers.get('content-type')?.includes('application/json')
        ? await res.json()
        : {};
      if (!res.ok) throw new Error(data.error || 'invalid_mfa_code');
      onLoggedIn?.({ userId: data.userId, displayName: data.displayName });
      route('/dashboard', true);
    } catch (err) {
      setError(translate(err.message));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div class="login-screen">
      <Card title="4U — Inloggen">
        {step === 'credentials' && (
          <form onSubmit={submitCredentials} class="login-form">
            <label>
              <span>E-mail</span>
              <input
                type="email"
                value={email}
                onInput={e => setEmail(e.currentTarget.value)}
                autoComplete="username"
                required
              />
            </label>
            <label>
              <span>Wachtwoord</span>
              <input
                type="password"
                value={password}
                onInput={e => setPassword(e.currentTarget.value)}
                autoComplete="current-password"
                required
              />
            </label>
            {error && <div class="form-error">{error}</div>}
            <Button type="submit" disabled={busy}>{busy ? 'Bezig…' : 'Inloggen'}</Button>
          </form>
        )}

        {step === 'mfa' && (
          <form onSubmit={submitMfa} class="login-form">
            <p class="muted">Voer de 6-cijferige code uit je authenticator-app in.</p>
            <label>
              <span>TOTP-code</span>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                value={code}
                onInput={e => setCode(e.currentTarget.value.replace(/\D/g, ''))}
                autoComplete="one-time-code"
                autoFocus
                required
              />
            </label>
            {error && <div class="form-error">{error}</div>}
            <Button type="submit" disabled={busy || code.length !== 6}>{busy ? 'Verifiëren…' : 'Verifiëren'}</Button>
          </form>
        )}
      </Card>
    </div>
  );
}

function translate(code) {
  const messages = {
    invalid_credentials: 'E-mail of wachtwoord is onjuist.',
    account_inactive: 'Account is gedeactiveerd.',
    account_locked: 'Account is tijdelijk vergrendeld na te veel mislukte pogingen.',
    mfa_setup_required: 'MFA is niet ingesteld voor dit account. Run `npm run seed-admin` om het secret te bekijken.',
    invalid_mfa_code: 'De code klopt niet. Probeer het opnieuw.',
    mfa_required: 'Login eerst met je e-mail en wachtwoord.'
  };
  return messages[code] || 'Er ging iets mis. Probeer het opnieuw.';
}
